'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageOptions = require('./PageOptions');

var _PageOptions2 = _interopRequireDefault(_PageOptions);

var _handleStateChangeOnClient = require('./handleStateChangeOnClient');

var _handleStateChangeOnClient2 = _interopRequireDefault(_handleStateChangeOnClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _PageOptions2.default)(_handleStateChangeOnClient2.default);
//# sourceMappingURL=browser.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/PageOptions/browser.js
 ** module id = 461
 ** module chunks = 1
 **/